import {Grid} from "@material-ui/core";
import React from "react";
import {Controller} from "react-hook-form";
import styled from "styled-components";
import apiHelper from "../../util/ApiHelper";
import {modal} from "../../util";

const DropZone = styled.div`
  width: 100%;
  height: 40px;
  background: #ffffff;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* padding: 11px 12px; */

  position: relative;

  input {
    display: none;
  }

  label {
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #c8c8c8;
    cursor: pointer;
    display: block;
    padding: 11px 12px;
    width: 100%;
    /* pointer-events: none; */
  }

  .dummyBtn {
    width: 85px;
    height: 30px;
    background: #ffffff;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    border-radius: 3px;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    color: #999999;
    position: absolute;
    right: 4px;
    top: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #f5f5f5;
    }
  }
`;

const ImageFrame = styled.div`
  position: relative;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > img {
    position: absolute;
    transition: 100ms all cubic-bezier(0.39, 0.575, 0.565, 1);
    transform-origin: center left;
    z-index: 10;
  }

  /* &:hover > img {
    transform: scale(7);
    box-shadow: 0 0 5px hsla(0, 0%, 0%, 0.4);
  } */
`;

const A = styled.a`
  color: #306F9D;
  text-decoration: none;
`;

function ImageUpload(props) {
    if (!props.control) {
        throw new Error("Missing control");
    }

    const uploadFile = async (file) => {
        try {
            const result = await apiHelper.cinefan.uploadFile(file);
            console.log(result.data.url);
            return result.data.url;
        } catch (err) {
            console.log(err);
        }
    };

    const handleFileUpload = async (event, onChange) => {
        console.log(event);
        console.log(event.target.name);
        const file = event.target.files[0];
        if (file) {
            const url = await uploadFile(file);
            onChange(url, {shouldDirty: true});
        }
    };

    return (
        <Controller
            name={props.name}
            control={props.control}
            render={({
                         field: {
                             value,
                             onChange,
                             name,
                             ...rest
                         },
                         fieldState: {error},
                     }) => {
                return (
                    <Grid container xs={12} spacing={2}
                          direction="column">
                        <Grid item>
                            <DropZone>
                                <label
                                    htmlFor={props.name}>{props.label}</label>
                                <label htmlFor={props.name}
                                       className="dummyBtn">
                                    Choose
                                </label>
                                <input
                                    id={props.name}
                                    type="file"
                                    onChange={(event) => {
                                        handleFileUpload(event, onChange);
                                    }}
                                />
                            </DropZone>
                        </Grid>
                        {value && (
                            <Grid container item
                                  alignItems="center">
                                <ImageFrame>
                                    <img src={value}
                                         alt={value}
                                         style={{maxHeight: "28px", cursor: "pointer"}}
                                         onClick={() => window.open(value, '_blank').focus()}
                                    />
                                </ImageFrame>
                                &nbsp;
                                <A href={value}
                                   target="_blank"><small>{value.split("/").pop()}</small></A>
                                <small
                                    style={{
                                        marginLeft: "20px",
                                        textDecoration: "underline",
                                        color: "#962013",
                                        cursor: "pointer",
                                    }}
                                    onClick={async () => {
                                        const decision = await modal.fire({
                                            title: "Delete Image",
                                            text: "Are you sure to delete this image?",
                                            showCancelButton: true,
                                            confirmButtonText: `Delete`,
                                        });
                                        if (decision.isConfirmed) {
                                            onChange(null, {shouldDirty: true});
                                        }
                                    }}
                                >
                                    Delete
                                </small>
                            </Grid>
                        )}
                    </Grid>
                );
            }}
        />
    );
}

export default ImageUpload;
